import type { Batch } from "@/commands/batch/batch";
import { out } from "@/lib/output/out";

export function printBatchQuestion(question: Batch["questions"][number]): void {
  out.line();
  if (question.header) {
    out.line(out.paint(out.cell(question.header), "dim"));
  }
  out.line(
    `${out.paint(out.cell(question.id), "dim")} ${out.safe(question.body)}`,
  );
  if (question.image) {
    out.line(out.paint(`    (image) ${out.cell(question.image)}`, "dim"));
  }
  for (const option of question.options) {
    const recommended = option.id === question.recommendedOptionId;
    // Image-only options still need an identifiable terminal label.
    const label = option.label
      ? out.cell(option.label)
      : option.image
        ? out.paint(`(image) ${out.cell(option.image)}`, "dim")
        : out.paint("(no label)", "dim");
    out.line(
      `    ${out.cell(option.id)}) ${label}${recommended ? out.paint("  ← recommended", "green") : ""}`,
    );
  }
  if (question.allowFreeText) {
    out.line(out.paint("    free text accepted", "dim"));
  }
}
